import { Box, Flex, Heading, HStack, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiAward } from "react-icons/fi";
import type { EvalBidDto } from "../../../../autogen/bff-api";

export const EvaluationRanking = ({ bids }: { bids: EvalBidDto[] }) => {
  const { t } = useTranslation();
  const ranked = [...bids].sort((a, b) => a.rank - b.rank);

  return (
    <Box>
      <Heading size="sm" mb="3">
        {t("Ranking")}
      </Heading>
      <Stack spacing="2">
        {ranked.map((bid) => {
          const isWinner = bid.rank === 1;
          return (
            <Flex
              key={bid.bidId}
              align="center"
              gap="4"
              px="5"
              py="3"
              rounded="lg"
              border="1px solid"
              borderColor={isWinner ? "green.200" : "smBorder"}
              bg={isWinner ? "green.50" : "smBackground"}
            >
              <Flex
                align="center"
                justify="center"
                boxSize="9"
                rounded="full"
                bg={isWinner ? "smPrimary" : "smBackgroundSecondary"}
                color={isWinner ? "white" : "smMuted"}
                fontWeight="bold"
                flexShrink={0}
              >
                {bid.rank}
              </Flex>
              <Box flex="1">
                <Text fontWeight="semibold" color="smText">
                  {bid.supplierName || t("Unknown")}
                </Text>
                {bid.effectivePrice?.value != null && (
                  <HStack spacing="2" align="baseline">
                    <Text
                      fontSize="sm"
                      color={bid.priceOverride ? "smPrimary" : "smMuted"}
                      fontWeight={bid.priceOverride ? "semibold" : "normal"}
                    >
                      {bid.effectivePrice.value.toLocaleString("nb-NO")} {bid.effectivePrice.currency}
                    </Text>
                    {bid.priceOverride && bid.price?.value != null && (
                      <Text
                        fontSize="xs"
                        color="smMuted"
                        textDecoration="line-through"
                        aria-label={
                          t("Supplier's submitted price: {{amount}} {{currency}}", {
                            amount: bid.price.value.toLocaleString("nb-NO"),
                            currency: bid.price.currency,
                          }) ?? ""
                        }
                      >
                        {bid.price.value.toLocaleString("nb-NO")} {bid.price.currency}
                      </Text>
                    )}
                  </HStack>
                )}
              </Box>
              <Text fontWeight="bold" fontFamily="mono" color={isWinner ? "smPrimary" : "smText"}>
                {bid.weightedTotal.toFixed(1)}
              </Text>
              {isWinner && <Box as={FiAward} color="green.500" boxSize="5" />}
            </Flex>
          );
        })}
      </Stack>
    </Box>
  );
};
